export const LIVE_RECONNECT_INTERVAL = 10 * 1000; // 10s
export const IDLE_RECONNECT_INTERVAL = 60 * 60 * 1000; // 1h
